/* Threads of Gulab — cart drawer + live cart. No page loads. */
window.TG = (function () {
  var busy = false;

  function cur() {
    var el = document.querySelector('[data-currency]');
    return (el && el.getAttribute('data-currency')) || 'USD';
  }
  function money(cents) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur() }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function badge(n) {
    var el = document.querySelector('[data-bag-count]');
    if (!el) return;
    el.textContent = n;
    if (n > 0) el.classList.remove('is-empty'); else el.classList.add('is-empty');
    el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
  }
  function drawer() { return document.querySelector('[data-tg-drawer]'); }

  function open() {
    var d = drawer(); if (!d) return;
    d.classList.add('open');
    document.documentElement.classList.add('tg-lock');
    sync();
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('open');
    document.documentElement.classList.remove('tg-lock');
  }

  function render(cart) {
    badge(cart.item_count);
    var d = drawer(); if (!d) return cart;
    var body = d.querySelector('[data-cd-body]');
    var foot = d.querySelector('[data-cd-foot]');
    var sub = d.querySelector('[data-cd-sub]');
    if (!cart.items || !cart.items.length) {
      if (body) body.innerHTML = '<p class="tg-cd-empty">Your bag is empty</p>';
      if (foot) foot.classList.add('tg-hide');
      return cart;
    }
    if (foot) foot.classList.remove('tg-hide');
    var h = '';
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var img = it.image ? it.image : '';
      var max = (it.variant_id && typeof it.inventory_quantity === 'number') ? it.inventory_quantity : null;
      h += '<div class="tg-cd-line" data-line="' + (i + 1) + '">'
        + '<figure><a href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a></figure>'
        + '<div class="tg-cd-mid">'
        + '<h4><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h4>'
        + (it.variant_title && it.variant_title.indexOf('Default') === -1 ? '<p class="tg-cd-var">' + esc(it.variant_title) + '</p>' : '')
        + '<div class="tg-cd-q"><button type="button" data-q="-1" aria-label="Decrease">&minus;</button>'
        + '<span data-qv>' + it.quantity + '</span>'
        + '<button type="button" data-q="1" aria-label="Increase">+</button></div>'
        + '<button type="button" class="tg-cd-rm" data-rm>Remove</button>'
        + '</div>'
        + '<p class="tg-cd-price">' + money(it.final_line_price) + '</p>'
        + '</div>';
    }
    if (body) body.innerHTML = h;
    if (sub) sub.textContent = money(cart.total_price);
    return cart;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }
  function sync() {
    return getCart().then(function (c) { render(c); document.dispatchEvent(new CustomEvent('tg:cart', { detail: c })); return c; });
  }
  function note(msg) {
    var n = document.querySelector('[data-cd-note]');
    if (!n) return;
    n.textContent = msg || '';
    if (msg) { clearTimeout(n._t); n._t = setTimeout(function () { n.textContent = ''; }, 2600); }
  }
  function fly(img) {
    var target = document.querySelector('[data-bag-icon]');
    if (!img || !target || !img.getBoundingClientRect) return;
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width) return;
    var g = img.cloneNode(true);
    g.removeAttribute('class');
    g.style.cssText = 'position:fixed;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;object-fit:cover;z-index:99998;pointer-events:none;transition:transform .7s cubic-bezier(.42,.02,.3,1),opacity .7s ease;';
    document.body.appendChild(g);
    requestAnimationFrame(function () {
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
      var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      g.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.07)';
      g.style.opacity = '.2';
    });
    setTimeout(function () { if (g.parentNode) g.parentNode.removeChild(g); }, 760);
  }

  function add(id, imgEl) {
    if (busy) return Promise.reject(new Error('Busy'));
    busy = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        busy = false;
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add');
        fly(imgEl);
        setTimeout(function () { open(); }, 420);
        return sync();
      })
      .catch(function (e) { busy = false; throw e; });
  }

  function change(line, quantity) {
    if (busy) return Promise.resolve(null);
    busy = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        busy = false;
        if (!res.ok) { note((res.data && (res.data.description || res.data.message)) || 'Could not update'); }
        return sync();
      })
      .catch(function () { busy = false; note('Network problem'); return sync(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var bag = t.closest && t.closest('[data-bag-icon]');
    if (bag) { e.preventDefault(); open(); return; }
    if (t.closest && t.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }
    var line = t.closest && t.closest('.tg-cd-line');
    if (line) {
      if (t.hasAttribute && t.hasAttribute('data-q')) {
        e.preventDefault();
        var span = line.querySelector('[data-qv]');
        var q = (parseInt(span.textContent, 10) || 0) + Number(t.getAttribute('data-q'));
        if (q < 0) q = 0;
        span.textContent = q;
        change(line.getAttribute('data-line'), q);
        return;
      }
      if (t.hasAttribute && t.hasAttribute('data-rm')) {
        e.preventDefault();
        line.classList.add('going');
        change(line.getAttribute('data-line'), 0);
        return;
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  return { add: add, change: change, badge: badge, money: money, open: open, close: close, sync: sync, getCart: getCart, fly: fly, note: note };
})();